import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'educare-url-dialog',
  templateUrl: './url-dialog.component.html',
  styleUrls: ['./url-dialog.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, TranslateModule]
})
export class UrlDialogComponent {
  public readonly dialogRef = inject(MatDialogRef<UrlDialogComponent>);
  public readonly data = inject<{ url: string }>(MAT_DIALOG_DATA);

  urlCtrl: FormControl = new FormControl(this.data.url || '', [
    Validators.required,
    Validators.pattern(/^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i)
  ]);

  insert(): void {
    if (this.urlCtrl.valid) {
      this.dialogRef.close(this.urlCtrl.value);
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
